module.exports = __webpack_public_path__ + "static/media/baby shop.910ec002.gif";


//////////////////
// WEBPACK FOOTER
// ./src/img/baby shop.gif
// module id = 376
// module chunks = 0